(function () {
  "use strict";

  if (window.__pharmacistaCartRewardsLoaded) {
    return;
  }

  window.__pharmacistaCartRewardsLoaded = true;

  function getCartAddUrl() {
    var root =
      window.Shopify &&
      window.Shopify.routes &&
      window.Shopify.routes.root
        ? window.Shopify.routes.root
        : "/";

    root = root.replace(/\/?$/, "/");

    return root + "cart/add.js";
  }

  function showCartError(message) {
    if (
      window.T4SThemeSP &&
      typeof window.T4SThemeSP.Notices === "function"
    ) {
      window.T4SThemeSP.Notices(message, "warning");
      return;
    }

    window.alert(message);
  }

  document.addEventListener("click", async function (event) {
    var button = event.target.closest("[data-ph-add-gift]");

    if (!button) {
      return;
    }

    event.preventDefault();

    if (button.disabled || button.classList.contains("is-loading")) {
      return;
    }

    var variantId = Number(button.getAttribute("data-variant-id"));

    if (!variantId) {
      showCartError("تعذر تحديد القطعة الهدية.");
      return;
    }

    button.disabled = true;
    button.classList.add("is-loading");
    button.setAttribute("aria-busy", "true");

    try {
      var response = await fetch(getCartAddUrl(), {
        method: "POST",
        credentials: "same-origin",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json"
        },
        body: JSON.stringify({
          items: [
            {
              id: variantId,
              quantity: 1
            }
          ]
        })
      });

      var result = await response.json();

      if (!response.ok) {
        throw new Error(
          result.description ||
          result.message ||
          "تعذر إضافة القطعة الهدية."
        );
      }

      /*
       * Kalles يستمع لهذا الحدث:
       * يحدث محتوى السلة ويفتح الـCart Drawer.
       */
      document.dispatchEvent(
        new CustomEvent("cart:refresh:opend")
      );
    } catch (error) {
      button.disabled = false;
      button.classList.remove("is-loading");
      button.removeAttribute("aria-busy");

      showCartError(
        error.message ||
        "حدث خطأ أثناء إضافة القطعة، حاولي مرة أخرى."
      );
    }
  });
})();